const CompositedComponent = require('../components/utils/CompositedComponent');
const Tabs = require('../components/togglers/Tabs');
const Accordion = require('../components/togglers/Accordion');

class ProductTabs {
    constructor(domNode) {
        this.container = domNode;
        this.tabs = [];
    }

    init() {
        if (this.tabs.length) {
            this.tabs.forEach(component => component.init());
            return;
        }

        this.container.querySelectorAll('[data-role=tablist]').forEach(tabList => {
            const component = new Tabs(tabList);
            this.tabs.push(component);
            component.init();
        });
    }

    destroy() {
        this.tabs.forEach(component => component.destroy());
    }
}

module.exports = function () {
    const productTabs = document.querySelector('.js-product-full-info');

    if (productTabs) {
        new CompositedComponent(new Accordion(productTabs), window.styleConstants.breakpoint.small, new ProductTabs(productTabs));
    }

    document.querySelectorAll('.js-related-items-tabs')
        .forEach(tablist => new Tabs(tablist).init());
};
